import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import React, { useContext, useEffect } from 'react';
import {
	ICreateModifierGroupsContext,
	CreateModifierGroupsContext,
} from '../../../../createModifierGroupsState/createModifierGroupsContext';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantsMultipleSelect } from './components/RestaurantsMultipleSelect/RestaurantsMultipleSelect';
import { NameModifierGroupInput } from './components/NameModifierGroupInput';
import { ExternalIdField } from './components/ExternalIdField';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';
import { BtnBlock } from './components/BtnBlock';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

export const InputFields: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setIDCustomer,
		setFetchedCustomers,
		setIDsRestaurant,
		setFetchedRestaurants,
		changeNameOfModifierGroup,
		changeExternalId,
		generateUniqueExternalId,
		setFetchedTranslations,
		setTranslationTab,
		changeNameTranslation,
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		nameOfModifierGroup,
		externalId,
		translations,
		defaultCustomerLanguage,
		selectedTranslationTab,
	} = useContext<ICreateModifierGroupsContext>(CreateModifierGroupsContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			IDSelectedCustomer,
			IDsSelectedRestaurant,
			nameOfModifierGroup,
			externalId,
		});
	}, [IDSelectedCustomer, IDsSelectedRestaurant, nameOfModifierGroup, externalId]);

	const submit = async () => {
		const defaultTranslationIsEmpty =
			translations.find((translation) => translation.languageId === defaultCustomerLanguage?.id)?.name === '';
		if (defaultTranslationIsEmpty) {
			changeTypeOfModalWindow('defaultTranslationIsEmpty');
			return;
		}

		setDataForSubmit({
			name: nameOfModifierGroup,
			externalId,
			customerId: IDSelectedCustomer ? IDSelectedCustomer : '',
			restaurantIds: IDsSelectedRestaurant,
			translations,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<Text
						className={style.requiredLabel}
						translationNameSpace="form"
						translationKey="allFieldsRequiredLabel"
						theme="secondary"
						size="s"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<NameModifierGroupInput changeNameOfModifierGroup={changeNameOfModifierGroup} />
						<CustomerSelect
							setIDCustomer={setIDCustomer}
							setFetchedCustomers={setFetchedCustomers}
							IDSelectedCustomer={IDSelectedCustomer}
						/>
					</div>
					<div className={style.row}>
						<ExternalIdField changeExternalId={changeExternalId} />
						<Button onClick={generateUniqueExternalId} theme="primary">
							<Text
								translationNameSpace="form"
								translationKey="generateUniqueExternalId"
								asFragment={true}
							/>
						</Button>
					</div>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="translationsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<MenuTranslationForm
						className={style.translationForm}
						setFetchedTranslations={setFetchedTranslations}
						setTranslationTab={setTranslationTab}
						changeNameTranslation={changeNameTranslation}
						isShowLanguageName={false}
						IDSelectedCustomer={IDSelectedCustomer}
						translations={translations}
						selectedTranslationTab={selectedTranslationTab}
						nameLabel="nameOfModifierGroupLabel"
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="restaurantListHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<RestaurantsMultipleSelect
						setIDsRestaurant={setIDsRestaurant}
						setFetchedRestaurants={setFetchedRestaurants}
						IDSelectedCustomer={IDSelectedCustomer}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};
